export default __webpack_public_path__ + "static/media/cash-icon-home-mobile.98300b2c.webp";